import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = { href: "https://proip.info" }
const _hoisted_5 = { class: "billing-info" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Account")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "billing-info" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://proip.info/docs",
    class: "white"
  }, "Docs")
], -1)
const _hoisted_8 = { class: "right desktop" }
const _hoisted_9 = {
  key: 0,
  class: "user"
}
const _hoisted_10 = {
  key: 1,
  class: "user-edit"
}
const _hoisted_11 = {
  key: 2,
  class: "user-logout"
}
const _hoisted_12 = { class: "right mobile mobile-menu" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TheLogo = _resolveComponent("TheLogo")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SettingOutlined = _resolveComponent("SettingOutlined")
  const _component_LogoutOutlined = _resolveComponent("LogoutOutlined")
  const _component_MenuOutlined = _resolveComponent("MenuOutlined")
  const _component_TheMenuMobile = _resolveComponent("TheMenuMobile")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("a", _hoisted_4, [
          _createVNode(_component_TheLogo, {
            color: "white",
            width: "120px"
          })
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "white"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _hoisted_7
    ]),
    _createVNode("div", _hoisted_8, [
      (_ctx.store.state.auth.isAuthenticated)
        ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.store.state.auth.user.email), 1))
        : _createCommentVNode("", true),
      (_ctx.store.state.auth.isAuthenticated)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode(_component_router_link, { to: "/profile" }, {
              default: _withCtx(() => [
                _createVNode(_component_SettingOutlined)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.store.state.auth.isAuthenticated)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode(_component_LogoutOutlined, { onClick: _ctx.logOut }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_MenuOutlined, { onClick: _ctx.mobileMenuStatus }, null, 8, ["onClick"])
    ]),
    (_ctx.idDisplayMobileMenu)
      ? (_openBlock(), _createBlock(_component_TheMenuMobile, {
          key: 0,
          onLogout: _ctx.logOut,
          onClose: _ctx.mobileMenuStatus
        }, null, 8, ["onLogout", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}